import React from "react";
import { Select } from "antd";

const { Option } = Select;

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default class Component extends React.Component<any, any> {
  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'selected' implicitly has an 'any' type.
  onChange(selected) {
    const { locations, multiple } = this.props;

    if (multiple) {
      // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'locId' implicitly has an 'any' type.
      this.props.onChange(selected.map((locId) => locations.find((loc) => loc._id === locId)));
    } else {
      // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'loc' implicitly has an 'any' type.
      this.props.onChange(locations.find((loc) => loc._id === selected));
    }
  }

  render() {
    const { value, defaultValue, locations, label, multiple } = this.props;
    let { style } = this.props;
    style = style || { width: "100%" };

    if (value) {
      // controlled component
      return (
        <Select
          /* @ts-expect-error FIXME this wrong type */
          mode={multiple ? "multiple" : null}
          showSearch
          style={style}
          placeholder={label || "Select location(s)"}
          value={value}
          defaultValue={defaultValue}
          optionFilterProp="children"
          onChange={(v) => this.onChange(v)}
        >
          {/* @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'name' implicitly has an 'any' type. */}
          {locations.map(({ name, _id }) => (
            <Option key={_id} value={_id}>
              {name}
            </Option>
          ))}
        </Select>
      );
    }

    return (
      <Select
        /* @ts-expect-error FIXME this wrong type */
        mode={multiple ? "multiple" : null}
        showSearch
        style={style}
        data-testid="hcDrawer-location-dropdown"
        placeholder={label || "Select location(s)"}
        defaultValue={defaultValue}
        optionFilterProp="children"
        onChange={(v) => this.onChange(v)}
      >
        {/* @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'name' implicitly has an 'any' type. */}
        {locations.map(({ name, _id }) => (
          <Option key={_id} value={_id}>
            {name}
          </Option>
        ))}
      </Select>
    );
  }
}
